import { render, staticRenderFns } from "./modalEditYouTubeSetup.vue?vue&type=template&id=451de1f9&"
import script from "./modalEditYouTubeSetup.vue?vue&type=script&lang=js&"
export * from "./modalEditYouTubeSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports